import type {Result, UseCase} from 'framework';
import type {KeepScreenAwakePreference} from '../../domain/keep-screen-awake-preference.value-object';
import type {KeepScreenAwakePreferenceRepository} from '../ports/keep-screen-awake-preference.repository';

export class GetKeepScreenAwakePreference implements UseCase<[], KeepScreenAwakePreference> {
  constructor(private readonly repository: KeepScreenAwakePreferenceRepository) {}

  execute(): Promise<Result<KeepScreenAwakePreference>> {
    return this.repository.get();
  }
}
